import type {SerializedGraphNode} from "@cm/graph-v3"
import {deserializeGraphNode} from "@cm/graph-v3"
import {MaterialGraph} from "#material/nodes/base/graph/material-graph"

export function deserializeMaterialGraph(graph: SerializedGraphNode): MaterialGraph {
    const result = deserializeGraphNode(graph, "material")
    if (!(result instanceof MaterialGraph)) throw new Error(`Deserialized node is not a MaterialGraph (got ${result.nodeClass})`)
    return result
}
